export default "__VITE_ASSET__CLg8R4oT__"